<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        <v-row>
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Relatórios / Acompanhamento de Produtividade
            </div>
          </v-col>
          <v-col cols="11" class="pt-0">
            <v-row no-gutters>
              <v-col cols="2">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="ano"
                  :items="anos"
                  clearable
                  clear-icon="close"
                  label="Ano"
                  hide-details=""
                  append-icon="expand_more"
                  :loading="loadingSearch || loadingAnos"
                  :disabled="loadingSearch || loadingAnos"
                  outlined
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-combobox
                  :menu-props="{ offsetY: true}"
                  v-model="usina"
                  :items="usinas"
                  class="full_width ml-3"
                  :search-input.sync="searchUsina"
                  hide-selected
                  label="Usinas"
                  multiple
                  hide-details=""
                  clear-icon="close"
                  append-icon="expand_more"
                  @keyup="searchUsinas()"
                  :loading="loadingSearch || loadingUsinas"
                  :disabled="loadingSearch || loadingUsinas"
                  outlined
                  small-chips
                >
                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      v-if="item.text"
                      label
                      small
                    >
                      <span class="pr-2">
                        {{ item.text.split(' - ')[0] }}
                      </span>
                      <v-icon
                        small
                        @click="parent.selectItem(item)"
                      >
                        close
                      </v-icon>
                    </v-chip>
                  </template>
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title v-if="searched">
                          Nenhnum resultado encontrado com "<strong>{{ searchUsina }}</strong>".
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          Buscar por nome da usina
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="1">
                <div class="ml-3 search_btn">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="ui-btn-inherit ui-search_btn" v-bind="attrs" v-on="on" :loading="loadingSearch" :disabled="loadingSearch" @click="applyFilter()">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </template>
                    <span>Filtrar</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" class="pt-0 text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit mt-1" v-bind="attrs" v-on="on" @click="print()">
                  <v-icon large color="primary">
                    print
                  </v-icon>
                </v-btn>
              </template>
              <span>Imprimir relatório</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
      <div id="print" v-if="dados && dados.length > 0">
        <div class="impressao__header text-center">
          <img v-if="!user.logo_sistema" class="impressao__logo" src="@assets/img/logo.png" alt="SolarMaker">
          <img v-else class="impressao__logo" :src="user.logo_sistema" alt="Logo sistema">
          <p>Relatório de Acompanhamento de Produtividade</p>
          <p>Ano: {{ano}}</p>
        </div>
        <div v-for="(usina, indexUsina) in dados" :key="indexUsina" class="mb-3" v-show="usina">
          <div class="text-h3 text-primary mb-2">
            {{usina.cliente ? usina.cliente.cli_nome : 'Cliente Excluído'}}
          </div>
          <div class="mb-4">
            <div class="text-h3 text-primary mb-2 unidade_cliente">
              Usina {{usina.usi_nome}}
            </div>
            <v-simple-table class="base_table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="20%">
                      Cidade
                    </th>
                    <th class="text-center" width="20%">
                      Potência
                    </th>
                    <th class="text-center" width="20%">
                      Eficiência
                    </th>
                    <th class="text-center" width="20%">
                      Geração anual prevista
                    </th>
                    <th class="text-center" width="20%">
                      Geração anual
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left">{{usina.usi_cidade}}/{{usina.usi_uf}}</td>
                    <td class="text-center">{{usina.projeto ? usina.projeto.usp_potencia.replace('.', ',') : 0}} kWp</td>
                    <td class="text-center">{{usina.projeto ? usina.projeto.usp_eficiencia : 0}}%</td>
                    <td class="text-center">{{usina.desempenho ? usina.desempenho.ano ? usina.desempenho.ano.projetado_anual : 0 : 0}} kWh</td>
                    <td class="text-center">{{usina.desempenho ? usina.desempenho.ano ? usina.desempenho.ano.produzido : 0 : 0}} kWh</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div v-if="usina.desempenho && usina.desempenho.projetado">
              <p class="mb-1 mt-2 pl-1 usina_desempenho impressao__hidden"><b>{{ano}}</b></p>
              <v-simple-table class="base_table usina_desempenho_table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" width="10%">
                        <span class="impressao__show">{{ano}}</span>
                      </th>
                      <th class="text-center" width="7.5%">
                        Janeiro
                      </th>
                      <th class="text-center" width="7.5%">
                        Fevereiro
                      </th>
                      <th class="text-center" width="7.5%">
                        Março
                      </th>
                      <th class="text-center" width="7.5%">
                        Abril
                      </th>
                      <th class="text-center" width="7.5%">
                        Maio
                      </th>
                      <th class="text-center" width="7.5%">
                        Junho
                      </th>
                      <th class="text-center" width="7.5%">
                        Julho
                      </th>
                      <th class="text-center" width="7.5%">
                        Agosto
                      </th>
                      <th class="text-center" width="7.5%">
                        Setembro
                      </th>
                      <th class="text-center" width="7.5%">
                        Outubro
                      </th>
                      <th class="text-center" width="7.5%">
                        Novembro
                      </th>
                      <th class="text-center" width="7.5%">
                        Dezembro
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr>
                      <td class="text-left">Participação</td>
                      <td class="text-center" v-for="(mes, indexMes) in 12" :key="indexMes">{{mes}}</td>
                    </tr> -->
                    <tr v-if="usina.desempenho.projetado">
                      <td class="text-left">Expectativa (kWh)</td>
                      <td class="text-center" v-for="(mes, indexMes) in 12" :key="indexMes">{{usina.desempenho.projetado[meses[indexMes]]}}</td>
                    </tr>
                    <tr v-if="usina.projeto">
                      <td class="text-left">Objetivo Mínimo (kWh)</td>
                      <td class="text-center" v-for="(mes, indexMes) in 12" :key="indexMes">{{usina.projeto['usp_objetivo_minimo_' + meses[indexMes].toLowerCase()] || '-'}}</td>
                    </tr>
                    <tr v-if="usina.desempenho.produzido">
                      <td class="text-left">Produção (kWh)</td>
                      <td class="text-center" v-for="(mes, indexMes) in 12" :key="indexMes">{{usina.desempenho.produzido[meses[indexMes]]}}</td>
                    </tr>
                    <tr v-if="usina.desempenho.desempenho">
                      <td class="text-left">Produtividade</td>
                      <td class="text-center" v-for="(mes, indexMes) in 12" :key="indexMes">{{retornoPorcentagem(usina.desempenho.desempenho[meses[indexMes]])}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </div>
        <div v-if="!dados.length">
          Nenhum dado encontrado.
        </div>
      </div>
      <div v-else>
        Nenhum dado encontrado.
      </div>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import Printd from 'printd'
import _debounce from 'lodash.debounce'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      user: null,
      loading: false,
      loadingAnos: false,
      ano: '',
      anos: [],
      loadingSearch: false,
      usinas: [],
      loadingUsinas: false,
      usina: '',
      usinaSearch: '',
      concessionaria: null,
      search: '',
      searchUsina: '',
      searched: false,
      concessionarias: [],
      loadingConcessionarias: false,
      unidade: null,
      unidades: [],
      loadingUnidades: false,
      dados: [],
      meses: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
    }
  },
  methods: {
    async print () {
      const d = new Printd()
      let styles = [
        `
          body {
            overflow: hidden;
            font-family: "Arial", sans-serif !important;
          }
          p, strong, b, small, span, q, i, td {
            color: #000!important;
            font-size: .85rem!important;
            line-height: .9rem!important;
            word-break: keep-all!important;
          }
          .v-application {
            font-family: "Arial", sans-serif !important;
          }
        `,
        `
          .impressao__header {
            width: 100%;
            text-align: center;
            color: #000!important;
          }
          .impressao__header p {
            margin-top: 1em;
            font-size: 14px;
            font-weight: bold;
          }
          .impressao__logo {
            max-width: 20%;
            color: #000!important;
          }
          .impressao__footer {
            bottom: 0;
            position: fixed;
            width: 100%;
            display: none;
          }
          .impressao__footer_text {
            text-align: center;
            color: #d0d0d0;
            font-size: 11px;
            padding-top: 5px;
          }
          .impressao__footer_hr {
            margin-bottom: 10px;
          }
          .impressao__break {
            page-break-after: always;
          }
          .impressao__footer, .impressao__footer-space {
            height: 2em;
          }
          .unidade_cliente {
            font-size: 13px!important;
          }
          .usina_desempenho {
            margin-top: 1em;
            font-size: 11px!important;
          }
          .usina_desempenho_table {
            width: 100%;
          }
          .usina_desempenho_table td, .usina_desempenho_table th {
            font-size: 11px!important;
          }
          #print .text-h3 {
            font-weight: bold;
            font-size: 13px;
            margin-top: 3em;
          }
          @media screen {
            .impressao__footer {
              display: none;
            }
          }
          @media print {
            thead {display: table-header-group;}
            tfoot {display: table-footer-group;}
            button {display: none;}
            body {margin: 0;}
            * {
              color: #000!important;
            }
            .v-data-table th {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              min-width: 4em;
            }
            .v-data-table td {
              border-bottom: thin solid rgba(0,0,0,.12)!important;
              max-width: 20em;
            }
            .v-data-table .text-center {
              text-align: center;
            }
            p {
              widows: 3;
            }
            .impressao__hidden {
              display: none;
            }
            .impressao__show {
              display: block!important;
            }
            .impressao__footer {
              display: block;
            }
            .impressao__header {
              display: block;
              width: 100%;
              color: #000!important;
            }
          }
          @page {
            size: A4 landscape !important;
            margin: 12mm;
          }
        `,
        'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
        'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
      ]

      let documento = document.getElementById('print')
      await d.print(documento, styles)
    },
    retornoPorcentagem (valor) {
      if (valor === '-') return valor
      return valor + '%'
    },
    async getAnos () {
      const year = new Date().getFullYear()
      this.loadingAnos = true
      let retorno = await Array.from({length: year - 2015}, (item, index) => 2015 + index + 1)
      this.loadingAnos = false
      this.ano = year
      this.anos = retorno.reverse()
    },
    searchUsinas: _debounce(function () {
      if (this.searchUsina.length < 3) return
      this.getUsinas()
    }, 500),
    async getUsinas () {
      this.loadingUsinas = true
      let endpoint = 'usinas'
      if (this.searchUsina) {
        endpoint += `?busca=${this.searchUsina}`
      }
      await Api.get(endpoint)
        .then(res => {
          var arrayUsi = []
          res.data.map(usi => {
            let text = usi.usi_nome
            if (usi.cliente) {
              text += ` - ${usi.cliente.cli_nome}`
            }
            arrayUsi.push({
              'text': text,
              'value': usi.uuid_usi_id
            })
          })
          this.searched = true
          this.usinas = arrayUsi
          this.loadingUsinas = false
        })
        .catch(err => {
          this.loadingUsinas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usinas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    applyFilter () {
      this.loading = true
      this.loadingSearch = true
      if (this.usina.length > 0) {
        let usis = ''
        this.usina.map(mod => {
          if (mod.value) {
            usis += '&usina[]=' + mod.value
          }
        })
        this.usinaSearch = usis
      }
      let query = Object.assign({},
        this.ano ? { ano: this.ano } : '',
        this.usina ? { usina: JSON.stringify(this.usina) } : '',
        this.usinaSearch ? { usinaSearch: this.usinaSearch } : ''
      )
      this.$router.replace({name: 'RelatoriosProdutividade', query: query}).catch(() => {})

      this.getDados()
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.ano) this.ano = Number(filters.ano)
      if (filters.usinaSearch) this.usinaSearch = filters.usinaSearch
      if (filters.usina) this.usina = JSON.parse(filters.usina)
      this.getAnos()
    },
    async getDados () {
      this.loading = true
      let endpoint = '?filtro='
      if (this.ano) {
        endpoint += `&ano=${this.ano}`
      }
      if (this.usina) {
        endpoint += this.usinaSearch
      }

      await Api.get('relatorios/acompanhamento-usinas' + endpoint)
        .then(res => {
          this.dados = res.data
          this.loading = false
          this.loadingSearch = false
        })
        .catch(err => {
          this.dados = []
          this.loading = false
          this.loadingSearch = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar o relatório de acompanhamento de produtividade!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_lista {
  border: 1px $primary solid;
  border-left-width: 10px;
  height: 100%;
  padding: 15px;
  .text-h3 {
    margin-bottom: 25px;
    position: relative;
    &:before {
      background: $primary;
      bottom: -10px;
      content: '';
      height: 1px;
      left: -15px;
      position: absolute;
      width: calc(100% + 30px);
    }
  }
  @media (max-width: 767px){}
}
.impressao__header {
  width: 100%;
  display: none;
}
.usina_desempenho {
  font-size: 16px!important;
}
.impressao__show {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/atendimento/Produtividade.vue